module.exports = __webpack_public_path__ + "img/play.96c13b26.png";